import React from "react";
import { observer } from "mobx-react";
import { Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";

import { ReportDocumentSection } from "@app/constants";

import BubbleItemContainer from "./bubble-item-container";

const CaptisLinkBubble = observer(({ isInLandscape, index, zIndex, mouseIn, metadata, editor }) => {
    if (!editor) {
        return;
    }

    const isArticle = metadata.type === ReportDocumentSection.CAPTIS_LINK.TYPE.ARTICLE;
    const hasDocument = isArticle
        ? !!metadata.articleId
        : !!editor.storage["captis-link"].store.hasDocument(metadata.documentId);

    const openLink = async () => {
        let href;

        if (metadata.type === ReportDocumentSection.CAPTIS_LINK.TYPE.SOURCE_DOCUMENT) {
            href = editor.commands.buildSourceDocumentHref(metadata);
        } else if (isArticle) {
            href = editor.commands.buildArticleHref(metadata);
        }

        if (href && hasDocument) {
            window.open(href, metadata.target || "_blank").focus();
        }
    };

    return (
        <BubbleItemContainer
            onClick={openLink}
            isInLandscape={isInLandscape}
            index={index}
            zIndex={zIndex}
            mouseIn={mouseIn}
            classNames={{
                "captis-link-bubble": true,
                "captis-link-bubble-invalid": !hasDocument,
            }}
        >
            <Tooltip title={!hasDocument && "Invalid reference"} placement="bottomLeft">
                <LinkOutlined />
            </Tooltip>
        </BubbleItemContainer>
    );
});

export default CaptisLinkBubble;
